// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__KViWQ","brand":"Nav_brand__2n013"};